export default "__VITE_ASSET__Clo7Ktq4__"